export const INSTANCES_CATALOG_TYPE = 'instancesCatalog' as const

export type InstancesCatalogItem = {
    action: string
    name: string
}
